import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useExcelExport } from "@/hooks/useExcelExport";

interface ExcelExportButtonProps {
  rows: Record<string, string>[];
  sheetName?: string;
  fileName?: string;
  disabled?: boolean;
}

export const ExcelExportButton = ({ rows, sheetName = "Sheet1", fileName = "export.xlsx", disabled }: ExcelExportButtonProps) => {
  const { exportToExcel } = useExcelExport();

  return (
    <Button variant="outline" size="sm" onClick={() => exportToExcel(rows, sheetName, fileName)} disabled={disabled} title="Download Excel">
      <Download className="w-4 h-4" /> Export Data 
    </Button>
  );
};
